/* eslint-disable complexity */
import React, { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import "./index.less";
import moment, { Moment } from "moment";
import {
  ChatMessageType,
  Employee,
  MessageEmitBody,
  MessageStatus,
  Session,
  SessionType
} from "@/types/chat";
import { useTranslation } from "react-i18next";
import DefaultPage from "@/components/DefaultPage";
import { CompDataLoadState, DefaultPageType } from "@/models";
import InfiniteScroll from "react-infinite-scroller";
import { List } from "antd";
import "moment/locale/zh-cn";
import { Avatar } from "@/baseComponents/Avatar";
import { MessageDateFormType, MessageSendType } from "@/types/chat/enum";
import { getMessageDateFormat } from "@/utils/date";
import { formatMatchContext, processEmoji } from "../utils";
import {
  convertEmployeeToString,
  getMessageSendType,
  isEqualEmployee,
  isEqualUid,
  isShowAlias
} from "@/utils/chat/message";
import Loading from "@/components/Loading";
import { getHeadImgThumbUrl, isChatPage } from "@/utils/chat/index";
import ComGroupAlias from "@/baseComponents/ComGroupAlias";
import { tagsNode } from "@/components/AddressBook/common";
import DownloadFile from "@/baseComponents/Chat/message/File/History";
import { MediaItem } from "../Media";
import Voice from "@/components/chat/message/Voice";
import JoyspaceFile from "@/components/chat/message/message-components/JoyspaceFile";
import Share from "@/components/chat/message/share";
import { useHistory } from "react-router-dom";
import {
  parseUidFromSingleSessionId,
  parseUidFromString
} from "@jd/jdee.im.sdk/lib/es/utils/utils";
import UnSupport from "../../message/UnSupport";
import Text from "@/components/chat/message/Text";

export interface ISearchMessageProps {
  currentSession: Session;
  currentEmployee: Employee;
  jumpTo?: () => void;
  handleJump?: (message: any) => void;
  onClickClose?: () => void;
  dataSource?: any[];
  loadMore?: () => void;
  isLoading?: boolean;
  hasMore?: boolean;
  searchFilter?: any;
  mark?: boolean;
  canJump?: boolean;
  currentTab?: string;
  setStartMessageId?: any;
}

function MessageItem(props: {
  item: any;
  jumpTo?: () => void;
  currentSession: any;
  children: any;
}) {
  const { item, jumpTo, currentSession, children } = props;
  return (
    <div className="message-item" key={item.id}>
      <div className="head-img">
        <Avatar
          src={getHeadImgThumbUrl(item.sender.avatar, 150, 150)}
          name={item.sender.name || ""}
        />
      </div>
      <div className="message">
        <div className="name-time">
          <div className="name-tag">
            <div className="name">{formatMatchContext(item.sender.name, "")}</div>
            <ComGroupAlias user={item.sender} session={currentSession} />
            {tagsNode(item.sender.labelInfoList)}
          </div>
          <div className="time">
            {typeof jumpTo === "function" && (
              <div className="view-context-btn" onClick={() => jumpTo?.()}>
                定位到聊天位置
              </div>
            )}
            {getMessageDateFormat(item.timestamp, MessageDateFormType.DATE_AGGREGATION, "")}
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

export default function SearchMessageComm(props: ISearchMessageProps) {
  const {
    currentSession,
    currentEmployee,
    onClickClose,
    dataSource = [],
    searchFilter = {},
    isLoading = false,
    hasMore = true,
    mark = false,
    canJump = false,
    loadMore,
    currentTab,
    setStartMessageId,
    handleJump
  } = props;
  const history = useHistory();

  const handleInfiniteOnLoad = () => {
    loadMore?.();
  };

  return (
    <div className="search-history search-text">
      <div className="search-history-wrapper">
        <div className="search-history-content">
          <div className="search-history-result">
            {!isLoading && dataSource.length === 0 && (
              <div className="illustration">
                <DefaultPage
                  dataType={CompDataLoadState.NODATA}
                  pageType={DefaultPageType.SEARCH_HISTORY}
                />
              </div>
            )}
            {dataSource.length > 0 && (
              <div className={`${mark ? "mark" : ""} message-list`}>
                {searchFilter?.startTimestamp && searchFilter?.endTimestamp ? (
                  <div className="search-history-timeline">
                    <span className="search-history-line-left" />
                    {searchFilter?.startTimestamp ? (
                      <span className="search-history-start-txt">
                        {moment(searchFilter?.startTimestamp).format("YYYY-MM-DD")}
                      </span>
                    ) : null}
                    {searchFilter?.endTimestamp ? <span>-</span> : null}
                    {searchFilter?.endTimestamp ? (
                      <span className="search-history-end-txt">
                        {moment(searchFilter?.endTimestamp).format("YYYY-MM-DD")}
                      </span>
                    ) : null}
                    <span className="search-history-line-right" />
                  </div>
                ) : null}
                <InfiniteScroll
                  initialLoad={false}
                  pageStart={0}
                  loadMore={handleInfiniteOnLoad}
                  hasMore={!isLoading && hasMore}
                  useWindow={false}
                >
                  <List
                    dataSource={dataSource}
                    renderItem={(item, index) => {
                      if (item.type === ChatMessageType.TEXT) {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={() => handleJump?.(item)}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <div className="context-wrapper">
                              {/* <div
                                className="text-content dangerous-message-html"
                                dangerouslySetInnerHTML={{
                                  __html: processEmoji(
                                    formatMatchContext(
                                      isShowAlias(currentSession) && (item as any).atContent
                                        ? (item as any).atContent
                                        : (item as any).content,
                                      searchFilter?.searchKey
                                    )
                                  )
                                }}
                              /> */}
                               <Text
                                  message={item}
                                  sessionType={currentSession.sessionType}
                                  sendType={getMessageSendType(item, currentEmployee, currentSession)}
                                  notShowReply={true}
                                />
                            </div>
                          </MessageItem>
                        );
                      } else if (
                        item.type === ChatMessageType.FILE ||
                        item.type === ChatMessageType.EGOV_FILE
                      ) {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={canJump ? () => handleJump?.(item) : undefined}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <DownloadFile
                              message={item}
                              sendType={MessageSendType.OTHER}
                              searchKey=""
                              isHistoryAllTab={currentTab === "all"}
                            />
                          </MessageItem>
                        );
                      } else if (
                        item.type === ChatMessageType.IMAGE ||
                        item.type === ChatMessageType.VIDEO
                      ) {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={canJump ? () => handleJump?.(item) : undefined}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <MediaItem
                              item={item}
                              isDownload={false}
                              curMsg={null}
                              previewFunc={(msg: any) => { }}
                            />
                          </MessageItem>
                        );
                      } else if (item.type === ChatMessageType.VOICE) {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={canJump ? () => handleJump?.(item) : undefined}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <Voice message={item} sendType={MessageSendType.OTHER} />
                          </MessageItem>
                        );
                      } else if (item.type === ChatMessageType.TEMPLATE2) {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={canJump ? () => handleJump?.(item) : undefined}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <Share
                              message={item}
                              sessionType={currentSession?.sessionType}
                              sendType={MessageSendType.OTHER}
                              // eslint-disable-next-line @typescript-eslint/no-unused-vars
                              onReady={function (params: {
                                beginSend: boolean;
                                messageExtend: any;
                              }): {} {
                                throw new Error("Function not implemented.");
                              }}
                            />
                          </MessageItem>
                        );
                      } else if (item.type === ChatMessageType.JOYSPACEFILE) {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={canJump ? () => handleJump?.(item) : undefined}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <JoyspaceFile message={item} />
                          </MessageItem>
                        );
                      } else {
                        return (
                          <MessageItem
                            item={item}
                            jumpTo={canJump ? () => handleJump?.(item) : undefined}
                            currentSession={currentSession}
                          >
                            {mark && <div className="mark" />}
                            <UnSupport message={item} />
                          </MessageItem>
                        );
                      }
                    }}
                  />
                </InfiniteScroll>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
